/* eslint-disable camelcase */
const selectors = {
  placeholder: '[data-video-placeholder]',
  video_wrapper: '[data-video-wrapper]',
  src_desktop: '[data-video-desktop-source]',
  src_mobile: '[data-video-mobile-source]',
  autoplay: '[data-video-autoplay]',
  video_player: '[data-video-player]',
  video_player_source: '[data-video-player-source]',
};
class TakeoverVideo extends HTMLElement {
  constructor() {
    super();

    this.placeholder = document.querySelector(selectors.placeholder);
    this.src_desktop = document.querySelector(selectors.src_desktop);
    this.src_mobile = document.querySelector(selectors.src_mobile);
    this.autoplay = document.querySelector(selectors.autoplay);
    this.video_wrapper = document.querySelector(selectors.video_wrapper);
    this.video_player = document.querySelector(selectors.video_player);
    this.video_player_source = document.querySelector(
      selectors.video_player_source
    );
    this.large_screen = window.matchMedia('(min-width: 797px)');

    if (this.placeholder) {
      this.initialiseEventListeners();
    } else {
      this.initialiseVideo();
    }

    window.addEventListener('resize', () => {
      this.initialiseVideo();
    });

    this.playPauseToggle();
  }

  initialiseVideo() {
    if (this.large_screen.matches || !this.hasVideoLinkMobile()) {
      this.setAspectRatio('desktop');
      this.playDesktop();
    } else {
      this.setAspectRatio('mobile');
      this.playMobile();
    }
  }

  playDesktop() {
    if (this.hasVideoLinkDesktop()) {
      const src_desktop = this.src_desktop.dataset.videoDesktopSource;
      this.setVideoSrcAndPlay(src_desktop);
    }
  }

  playMobile() {
    if (this.hasVideoLinkMobile()) {
      const src_mobile = this.src_mobile.dataset.videoMobileSource;
      this.setVideoSrcAndPlay(src_mobile);
    }
  }

  setVideoSrcAndPlay(src) {
    if (this.video_player_source.src !== src) {
      this.video_player_source.src = src;
      this.video_player.load();
    }

    if (this.autoplay.dataset.videoAutoplay === 'true') {
      this.video_player.play();
    }
  }

  playPauseToggle() {
    this.video_wrapper.addEventListener('click', () => {
      if (this.video_player.paused) {
        this.video_player.play();
      } else {
        this.video_player.pause();
      }
    });
  }

  hasVideoLinkDesktop() {
    return this.src_desktop.dataset.videoDesktopSource.length > 0;
  }

  hasVideoLinkMobile() {
    return this.src_mobile.dataset.videoMobileSource.length > 0;
  }

  setAspectRatio(aspect) {
    if (aspect === 'mobile') {
      this.setMobileAspect();
    } else if (aspect === 'desktop') {
      this.setDesktopAspect();
    }
  }

  setMobileAspect() {
    this.video_wrapper.classList.remove('aspect-w-16', 'aspect-h-9');
    this.video_wrapper.classList.add('aspect-w-9', 'aspect-h-16');
  }

  setDesktopAspect() {
    this.video_wrapper.classList.remove('aspect-w-9', 'aspect-h-16');
    this.video_wrapper.classList.add('aspect-w-16', 'aspect-h-9');
  }

  initialiseEventListeners() {
    this.placeholder.addEventListener('click', () => {
      if (this.placeholder) {
        this.removePlaceholderAndPlay();
      }
    });
  }

  removePlaceholderAndPlay() {
    this.placeholder.classList.add('opacity-0');
    this.initialiseVideo();

    setTimeout(() => {
      this.placeholder.remove();
      this.placeholder = null;
    }, 500);
  }
}

customElements.define('takeover-video', TakeoverVideo);
